import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NgClass, NgTemplateOutlet }                   from '@angular/common';
import { MatIcon }                                     from '@angular/material/icon';
import { Subscription }                                from 'rxjs';

import { InternalRoutes }  from '../../data/internal-routes';
import { MenuService }     from '../../services/menu-service';
import { ButtonComponent } from '../buttons/button.component';

@Component({
  selector: 'pin-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  imports: [NgClass, MatIcon, ButtonComponent, NgTemplateOutlet]
})

export class MenuComponent implements OnInit, OnDestroy {
  @Input()
  userName: string;
  @Input()
  menuItemsTemplate: unknown;
  @Input()
  closeMenu: () => void;
  internalRoutes = InternalRoutes;
  subscription: Subscription;
  showMenu = false;
  private menuService = inject(MenuService);

  ngOnInit() {
    this.subscription = this.menuService.menuItem
      .subscribe(showMenu => this.showMenu = showMenu);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
